export const FIRST_NAMES = [
  'Andreea', 'Mihai', 'Elena', 'Cristian', 'Ioana', 'Alexandru', 'Gabriela', 'Bogdan',
  'Daniela', 'Florin', 'Raluca', 'Ștefan', 'Simona', 'Vlad', 'Cătălina', 'Adrian',
  'Mirela', 'Cosmin', 'Larisa', 'Marius', 'Diana', 'Radu', 'Anca', 'George',
  'Roxana', 'Sorin', 'Corina', 'Lucian', 'Monica', 'Dragoș', 'Irina', 'Paul',
] as const

export const LAST_NAMES = [
  'Popescu', 'Ionescu', 'Dumitrescu', 'Stan', 'Constantinescu', 'Rusu', 'Munteanu',
  'Neagu', 'Marin', 'Ciobanu', 'Toma', 'Dobre', 'Șerban', 'Voicu', 'Tudor',
  'Petrescu', 'Enache', 'Barbu', 'Preda', 'Stoica', 'Matei', 'Radu', 'Nistor', 'Iliescu',
] as const

export const CITIES = [
  'București', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Brașov',
  'Craiova', 'Galați', 'Ploiești', 'Oradea', 'Sibiu', 'Bacău',
] as const

export const COMPANIES_BY_VERTICAL: Record<string, string[]> = {
  florarie: ['Florăria Trandafirul', 'Grădina de Flori', 'Florăria Lalele & Co'],
  salon: ['Salon Elite Beauty', 'Studio Hair by Ana', 'Salon Glamour'],
  clinica: ['Clinica DentalCare', 'Centrul Medical Sanovita', 'Clinica ProVita'],
  service: ['AutoService Rapid', 'Atelierul lui Mitică', 'Service Auto Expert'],
  restaurant: ['Bistro Verde', 'Restaurant La Conac', 'Trattoria Bella'],
  retail: ['Fashion Corner', 'Boutique Elena', 'Magazin Sport Activ'],
  b2b: ['Distrib Prod SRL', 'AgroSupply România', 'BuildMat Distribuție'],
}

export const ALL_COMPANIES = Object.values(COMPANIES_BY_VERTICAL).flat()

export const TAGS = ['VIP', 'Nou', 'Fidel', 'Inactiv', 'Corporate', 'Recomandare', 'Risc de pierdere'] as const

export const CAMPAIGN_NAMES = [
  'Reduceri de Primăvară',
  'Campanie 8 Martie',
  'Black Friday 2026',
  'Programare — reamintire',
  'Felicitări de Crăciun',
  'Lansare colecție nouă',
  'Recomandă un prieten',
  'Reactivare clienți inactivi',
] as const

export const CONSENT_SOURCES = ['Tabletă recepție', 'Link SMS', 'Link Email', 'Link WhatsApp'] as const
